import api from '../api';
import { serviceReutils } from '../../utils/reutils';

export const ServiceTipoVeiculo = {
  ...serviceReutils({ name: 'rotas/v1/tipoVeiculo', api }),
};
